import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AirportRequestBody} from "app/types/service-types/AirportServiceTypes";
import {AirportService} from "app/services";
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {fetchAllAirports} from "./airports-list.slice";
import {errorMsg, successMsg} from "app/utils/MessageUtils";

interface CreateAirportStateParams {
  body: AirportRequestBody;
  onSuccess?: Function;
  onError?: Function;
}

export const createAirport = (params: CreateAirportStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AirportService.createAirport(params.body);
    if (response.status === 201) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Airport successfully added!' : 'Aeroporti u shtua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllAirports());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Image should not be greater than 1MB!' : 'Imazhi nuk duhet të jetë më i madh se 1MB!'));
    if (params.onError) params.onError();
    dispatch(setError(''));
  }
}

interface CreateAirportSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateAirportSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'configurations/airports',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;